import { BrowserRouter, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import ClientSurvey from 'pages/ClientSurvey';

function App() {
 
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={ <ClientSurvey /> } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
